import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=24db823b&lang=pug&"
import script from "./CartModal.vue?vue&type=script&lang=ts&"
export * from "./CartModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports